import { Link } from "react-router-dom";
import { ArrowLeft, FileSearch } from "lucide-react";

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-white" data-testid="cookies-policy-page">
      <nav className="border-b border-slate-200 bg-white">
        <div className="section-container flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="cookies-logo-link">
            <div className="w-8 h-8 rounded-lg overflow-hidden">
              <img src="https://customer-assets.emergentagent.com/job_bid-quality/artifacts/plxbtywa_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202026-03-12%20%D0%B2%2019.39.09.png" alt="AICallFront" className="w-full h-full object-cover" />
            </div>
            <span className="font-heading text-lg font-bold text-[#0F172A] tracking-tight">AICallFront</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#0F172A] transition-colors" data-testid="cookies-back-link">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <main className="section-container py-16 md:py-24 max-w-3xl">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#0F172A] tracking-tight mb-8">Advertising & Cookies Policy</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: December 2025</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">1. What Are Cookies</h2>
          <p>Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our platform.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">2. Types of Cookies We Use</h2>
          <h3 className="font-heading text-lg font-semibold text-[#0F172A] mt-6">Essential Cookies</h3>
          <p>These cookies are necessary for the basic functionality of our website. They enable core features such as page navigation and access to secure areas. The website cannot function properly without these cookies.</p>

          <h3 className="font-heading text-lg font-semibold text-[#0F172A] mt-6">Performance Cookies</h3>
          <p>These cookies collect anonymous information about how visitors use our website. They help us understand which pages are most popular, how visitors navigate the site, and if they experience any errors.</p>

          <h3 className="font-heading text-lg font-semibold text-[#0F172A] mt-6">Functionality Cookies</h3>
          <p>These cookies remember choices you make (such as your preferred language or region) and provide enhanced, more personalised features.</p>

          <h3 className="font-heading text-lg font-semibold text-[#0F172A] mt-6">Advertising Cookies</h3>
          <p>We may use advertising cookies to deliver relevant advertisements to you. These cookies track your browsing habits to help us show you adverts that are more relevant to your interests. They also limit the number of times you see an advertisement and help measure the effectiveness of advertising campaigns.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">3. Third-Party Cookies</h2>
          <p>Some cookies are placed by third-party services that appear on our pages. We do not control the use of these cookies. Third-party providers include analytics platforms and advertising networks that help us understand site usage and deliver relevant content.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">4. Managing Cookies</h2>
          <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>View what cookies are stored and delete them individually</li>
            <li>Block third-party cookies</li>
            <li>Block cookies from specific sites</li>
            <li>Block all cookies from being set</li>
            <li>Delete all cookies when you close your browser</li>
          </ul>
          <p>Please note that blocking or deleting cookies may impact your experience on our website.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">5. Advertising</h2>
          <p>AICallFront may display advertisements on our platform or through partner networks. We work to ensure that advertising content is relevant to our users in the small business and service provider sector. We do not sell your personal data to advertisers.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">6. Updates to This Policy</h2>
          <p>We may update this Advertising & Cookies Policy from time to time. Changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">7. Contact Us</h2>
          <p>For questions about our use of cookies and advertising, please contact us at:</p>
          <p>AICallFront<br />22 Tudor Street, City of London<br />London EC4Y 0AY, UK<br />Email: info@aicallfront.com<br />Phone: +44 20 3917 2500</p>
        </div>
      </main>
    </div>
  );
}
